/**
 * Created by calhosh on 12/22/2022
 */
import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import RemoteComponent from '../../Common/ModuleFederation/RemoteComponent';
import TimeTrackerPlaceholder from '../../Common/ModuleFederation/TimeTrackerPlaceholder';
import envConfig from '@ey/voltron-config';
import Utility from '../../../util/utilityfunctions';
import {labels} from '../../../util/utils';

export default function TimeTrackerContainer() {
	const engagement = useSelector((state) => state.engagement);
	const userPreferences = useSelector((state) => state.userPreferences);

	return (
		<StyledTimetrackerContainer className="StyledTimetrackerContainer kronosTimeTracker">
			<RemoteComponent
				id="aion"
				adConfig={envConfig.ad}
				engagementId={Utility.getEngagementIdFromUrl(window)}
				engagementCodes={engagement.allEngagementCodes}
				engagementDescription={engagement.engagementDescription}
				displayLanguage={userPreferences.displayLanguage}
				darkMode={Utility.getTheme() === 'dark'}
				newBaseFontSize
				numberFormat={userPreferences.numberFormat}
				userId={userPreferences.userGui}
				loadingFallback={<TimeTrackerPlaceholder placeholderMessage={labels.timeTrackerLoadingFallbackMessage} />}
				errorFallback={<TimeTrackerPlaceholder placeholderMessage={labels.timeTrackerErrorFallBackMessage} />}
			/>
		</StyledTimetrackerContainer>
	);
}

const StyledTimetrackerContainer = styled.section`
	position: relative;
	.MainContainerWrapper {
		height: 100% !important;
		.StyledTimeTrackerSection {
			z-index: 99 !important;
		}
	}
`;
